(function() {
  var thresholdShipping = 150000;
  var thresholdGift     = 300000;
  var initialized = false;
  var drawerObserver = null;
  var drawerObserverRoot = null;

  var formatter = new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });

  function updateDrawerProgress() {
    var card = document.getElementById('drawerProgressCard');
    if (!card) return;

    fetch('/cart.js', { cache: 'no-store', headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var bar        = document.getElementById('drawerProgressBarFill');
        var messageEl  = document.getElementById('drawerProgressMessage');
        var pctEl      = document.getElementById('drawerProgressPercentage');
        var cartIcon   = document.getElementById('drawerCartIcon');
        var giftIcon   = document.getElementById('drawerGiftIcon');
        var milestone1 = document.getElementById('drawerMilestone1');
        var milestone2 = document.getElementById('drawerMilestone2');

        if (!bar || !messageEl) return;

        // Pausamos el observer: los cambios que hacemos abajo (innerHTML, classList)
        // no deben disparar una nueva ejecución de esta misma función.
        if (drawerObserver) drawerObserver.disconnect();

        var cartTotal = cart.total_price / 100;

        // Progreso segmentado en dos tramos reales:
        // Tramo 1 (0% → 50% del track): $0 → $150.000 (envío gratis)
        // Tramo 2 (50% → 100% del track): $150.000 → $300.000 (obsequio)
        var percentage;
        if (cartTotal <= thresholdShipping) {
          percentage = (cartTotal / thresholdShipping) * 50;
        } else {
          var secondStageProgress = Math.min(cartTotal - thresholdShipping, thresholdGift - thresholdShipping);
          percentage = 50 + (secondStageProgress / (thresholdGift - thresholdShipping)) * 50;
        }
        percentage = Math.min(percentage, 100);

        var shippingReached = cartTotal >= thresholdShipping;
        var giftReached     = cartTotal >= thresholdGift;

        bar.style.width = Math.max(percentage, 5) + '%';

        bar.classList.remove('is-milestone-1', 'is-complete');
        if (giftReached) {
          bar.classList.add('is-complete');
        } else if (shippingReached) {
          bar.classList.add('is-milestone-1');
        }

        if (cartIcon) {
          var strokeColor = giftReached ? '#5a9e5a' : '#8c6e57';
          var paths = cartIcon.querySelectorAll('path, circle');
          paths.forEach(function(el) {
            el.setAttribute('stroke', strokeColor);
          });
          // Al llegar al 100% el carrito y el ícono/checkmark del hito final
          // caen en el mismo punto: ocultamos el carrito y dejamos solo el regalo.
          cartIcon.classList.toggle('is-hidden', giftReached);
        }

        if (giftIcon) {
          giftIcon.classList.toggle('is-visible', giftReached);
        }

        if (milestone1) milestone1.classList.toggle('is-reached', shippingReached);
        if (milestone2) milestone2.classList.toggle('is-reached', giftReached);

        if (pctEl) {
          pctEl.textContent = Math.round(percentage) + '%';
          pctEl.classList.toggle('is-complete', giftReached);
        }

        messageEl.classList.remove('is-milestone-1', 'is-milestone-2', 'is-complete');
        if (giftReached) {
          messageEl.classList.add('is-complete');
          messageEl.innerHTML = '¡Felicitaciones! Tienes <strong>envío gratis</strong> y un <strong>obsequio sorpresa</strong> 🎉🎁';
        } else if (shippingReached) {
          var amountForGift = thresholdGift - cartTotal;
          messageEl.classList.add('is-milestone-2');
          messageEl.innerHTML = '¡Envío gratis desbloqueado! Agrega <strong>' + formatter.format(amountForGift) + '</strong> más y llévate un obsequio 🎁';
        } else {
          var amountForShipping = thresholdShipping - cartTotal;
          messageEl.classList.add('is-milestone-1');
          messageEl.innerHTML = 'Agrega <strong>' + formatter.format(amountForShipping) + '</strong> más para obtener envío gratis';
        }

        // Reanudamos el observer en el siguiente tick, ya con nuestros propios
        // cambios aplicados y "vistos". Se reconecta sobre el mismo nodo raíz
        // estable (#shtCartDrawer), que nunca se destruye a sí mismo aunque
        // su contenido interno se re-renderice por completo.
        if (drawerObserver && drawerObserverRoot) {
          setTimeout(function() {
            drawerObserver.observe(drawerObserverRoot, { childList: true, subtree: true });
          }, 50);
        }
      })
      .catch(function(err) { console.error('Drawer progress error:', err); });
  }

  var originalFetch = window.fetch;
  window.fetch = function() {
    var args = arguments;
    var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url ? args[0].url : '');
    var result = originalFetch.apply(this, args);

    if (url.includes('/cart/add') || url.includes('cart_add_url')) {
      result.then(function(response) {
        if (response.ok) {
          setTimeout(function() {
            var cartDrawerForm = document.querySelector('sht-cart-drwr-frm');
            if (!cartDrawerForm || typeof cartDrawerForm.renderContents !== 'function') return;
            var drawerSection = document.querySelector('sht-cart-drwr');
            if (!drawerSection || typeof drawerSection.getSectionsToRender !== 'function') return;
            var sections = drawerSection.getSectionsToRender().map(function(s) { return s.id; });
            if (!sections.length) return;
            fetch(window.routes.cart_update_url, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ sections: sections, sections_url: window.location.pathname })
            })
            .then(function(r) { return r.json(); })
            .then(function(response) {
              cartDrawerForm.renderContents(response);
              setTimeout(updateDrawerProgress, 400);
            })
            .catch(function(err) { console.error('Drawer refresh error:', err); });
          }, 600);
        }
        return response;
      }).catch(function() {});
    }

    return result;
  };

  function init() {
    if (initialized) return;
    initialized = true;
    document.addEventListener('cart:updated', function() {
      setTimeout(updateDrawerProgress, 400);
    });

    // Red de seguridad: detecta CUALQUIER re-render del contenido del carrito
    // (agregar, quitar, cambiar cantidad, aplicar descuento, etc.) sin depender
    // de que el tema dispare un evento específico para cada acción.
    //
    // Importante: observamos #shtCartDrawer (el custom element raíz), NO
    // ".drawer__body" — ese nodo interno es justamente el que Shopify
    // reemplaza por completo en cada re-render, así que un observer apuntando
    // ahí queda "mirando" un nodo desconectado después del primer cambio y
    // deja de disparar. El elemento raíz nunca se destruye a sí mismo.
    drawerObserverRoot = document.getElementById('shtCartDrawer');
    if (drawerObserverRoot && window.MutationObserver) {
      var debounceTimer = null;
      drawerObserver = new MutationObserver(function() {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(updateDrawerProgress, 300);
      });
      drawerObserver.observe(drawerObserverRoot, { childList: true, subtree: true });
    }

    updateDrawerProgress();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();